export const NEWS_LOAD_SUCCESS = 'news/LOAD_SUCCESS';
export const NEWS_CHANGE_SUCCESS = 'news/CHANGE_SUCCESS';
export const NEWS_CREATE_SUCCESS = 'news/CREATE_SUCCESS';
export const NEWS_EDIT_SUCCESS = 'news/EDIT_SUCCESS';
export const NEWS_DELETE_SUCCESS = 'news/DELETE_SUCCESS';
export const SET_BUSY = 'news/SET_BUSY';
export const UNSET_BUSY = 'news/UNSET_BUSY';
